<template>
    <div class="columns is-centered is-vcentered is-mobile is-gapless">
        <ShareNetwork
                v-for="network in networks"
                :network="network.network"
                :key="network.network"
                :url="sharing.url"
                :title="sharing.title"
                :description="sharing.description"
                :data-event-clicktext="network.network"
                class="column is-narrow"
        >
            <span class="icon is-medium ml-3">
                <i :class="network.icon"></i>
            </span>
        </ShareNetwork>
    </div>
</template>

<script>
import Vue, {nextTick} from 'vue';
import VueSocialSharing from 'vue-social-sharing';

Vue.use(VueSocialSharing);

export default {
    props: {
        currentTitle: '',
        currentDescription: '',
    },
    data() {
        return {
            sharing: {
                url: window.location.href,
                title: '',
                description: ''
            },
            networks: [
                {network: 'facebook', name: 'Facebook', icon: 'icon-facebook'},
                {network: 'twitter', name: 'Twitter', icon: 'icon-twitter'},
                {network: 'email', name: 'Email', icon: 'icon-email'},
                {network: 'whatsapp', name: 'Whatsapp', icon: 'icon-whatsapp'},
                {network: 'telegram', name: 'Telegram', icon: 'icon-telegram'},
            ]
        }
    },
    mounted() {
        this.sharing.title = this.currentTitle || document.title;
        this.sharing.description = this.currentDescription || '';
    }
}
</script>